<template>
  <section>
    <br>
    <p class="p-style">
      Step 3: Questions & Answers
    </p>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text class="justify-center">
        <div
          v-if="!isQuestionsAvailable"
          class="no-file-alert"
        >
          <h4>
            No questions found. <br>Please click on the next button for continuing the process.
          </h4>
        </div>
        <v-form>
          <div
            v-for="(item, i) in questions"
            :key="item.id"
          >
            <p class="question-index">
              Question - {{ i + 1 }}
            </p>
            <p class="question-style">
              {{ item.question }}
            </p>
            <div
              v-for="(answer, ansindex) in item.answers"
              :key="`answer - ${ansindex}`"
              class="answer-div"
            >
              <v-checkbox
                v-model="answerSelected[item.id]"
                :value="answer.answer"
                hide-details
                dense
                filled
                color="#FF3700"
                light
                outlined
              >
                <template #label>
                  <span class="input__label">{{ answer.answer }}</span>
                </template>
              </v-checkbox>
            </div>
            <hr>
            <br>
          </div>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="#37474F"
              @click="cancel()"
            >
              Cancel
            </v-btn>
            <v-btn
              color="#FF3700"
              @click="questionsAnswered()"
            >
              Next
            </v-btn>
            <v-spacer />
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'QuestionsAndAnswers',
  components: {
    'centre-spinner': spinner,
  },
  data () {
    return {
      loading: false,
      cardBgImg: require('@/assets/img/cardBg.png'),
      answerSelected: {},
    };
  },
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    questions () {
      return this.$store.getters['questions/getOrgQuestions'];
    },
    isQuestionsAvailable () {
      if (this.questions.length > 0) {
        return true;
      }
      return false;
    },
  },
  mounted () {
    this.fetchOrgQuestions();
  },
  methods: {
    async fetchOrgQuestions () {
      await this.$store.dispatch('questions/fetchOrgQuestions');
    },
    async questionsAnswered () {
      if (this.questions.length !== Object.keys(this.answerSelected).length) {
        this.$store.dispatch('alert/onAlert', {
          message: 'All questions are mandatory.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        return;
      }
      this.loading = true;
      setTimeout(() => {
        this.$store.dispatch('questions/onAddUserSelectedAnswers', this.answerSelected);
        this.loading = false;
        this.$emit('questions-answered');
      }, 2000);
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.question-index {
  font-size: 14px;
  font-weight: bold;
  color: #546E7A;
  margin-bottom: 10px;
  font-family:'Times New Roman', Times, serif;
}
.question-style {
  font-size: 15px;
  font-weight: bold;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.answer-div {
  margin-bottom: 10px;
  margin-top: -10px;
}
.input__label {
  font-weight: bold;
  font-size: 15px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.no-file-alert {
  color: #C62828;
  font-size: 18px;
  text-align: center;
  font-family: 'Times New Roman', Times, serif;
  margin-bottom: 50px;
  margin-top: 50px;
}
</style>
